import React from 'react'

const Manual_proveedores_creacion_interno = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Proveedores - Creación de Proveedor Interno
        </h2>
        <iframe
          src="https://scribehow.com/embed/Provedores__Creacion_de_Proveedor_Interno__K9zM0mheS1i0DR2gUeuZXA?as=scrollable"
          className="scribe-iframe-general-176"
          width="100%"
          height="4200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_proveedores_creacion_interno
